/* TLC colour swatches, product page (Option A: labelled swipe row).
   Keeps the existing rules: 8 colours show first, "+ N more colours" shows the rest,
   every swatch still links to that colour's page. Adds a "Colour: name" label and
   puts the colour she's looking at first.
   On Sale row: colours that are marked down (compare at price above price) or tagged
   'finalsale' sit in their own "On sale in this style" row underneath, only when a style
   has both. snippets/tlc-sale-colours.liquid builds the colour rows (one line each with
   "+N", the On sale row) while the page loads. Pages without that snippet fall back to
   looking the colours up. */
(function () {
  var LIMIT = 8;

  function colourName() {
    var t = (document.querySelector('.product-form .product-title') || {}).textContent || '';
    var parts = t.split('|').map(function (p) { return p.trim(); }).filter(function (p) { return p && !/^(final sale|sale|pre-?order|coming soon)$/i.test(p); });
    return parts.length > 1 ? parts[parts.length - 1] : '';
  }

  function sharpen(img) {
    var src = img.getAttribute('src') || '';
    if (!src) return;
    var base = src.replace(/([?&])width=\d+/, '$1').replace(/[?&]$/, '');
    var j = base.indexOf('?') > -1 ? '&' : '?';
    img.setAttribute('srcset', base + j + 'width=160 160w, ' + base + j + 'width=320 320w');
    img.setAttribute('sizes', '52px');
  }

  function handleOf(url) {
    var m = String(url || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  /* Build the On Sale row under the main row and move the sale colours into it */
  function moveToSaleRow(box, sale) {
    var form = box.closest('.product-form') || document;
    if (form.querySelector('.tlcsw--sale')) return;
    var wrap = document.createElement('div');
    wrap.className = 'tlcsw-sale';
    wrap.innerHTML = '<div class="label tlcsw-lab tlcsw-lab--sale" role="heading" aria-level="2"><span class="tlcsw-lab__k">On sale in this style</span></div>' +
      '<div class="related-swatches tlcsw tlcsw--sale tlc2-colours" data-tlcsw="1"></div>';
    var row = wrap.querySelector('.tlcsw--sale');
    var w = box.style.getPropertyValue('--image-width'); if (w) row.style.setProperty('--image-width', w);
    sale.forEach(function (s) {
      s.classList.remove('tlc-swatch-hidden');
      s.style.removeProperty('display');
      var i = s.querySelector('img'); if (i) sharpen(i);
      row.appendChild(s);
    });
    var act = row.querySelector('.related-swatch--active');
    if (act && act !== row.firstElementChild) row.insertBefore(act, row.firstElementChild);
    /* fallback path only (pages without the snippet): show every sale colour */
    row.classList.add('tlc2-all');

    var tog = box.nextElementSibling && box.nextElementSibling.classList.contains('tlc-swatch-toggle') ? box.nextElementSibling : null;
    (tog || box).insertAdjacentElement('afterend', wrap);
    tidyMain(box);
  }

  /* the "+N" squares are made by snippets/tlc-sale-colours.liquid; here only the old
     "+ N more colours" text link is tidied */
  function tidyMain(box) {
    var tog = box.nextElementSibling && box.nextElementSibling.classList.contains('tlc-swatch-toggle') ? box.nextElementSibling : null;
    if (tog) {
      var left = box.querySelectorAll('.tlc-swatch-hidden').length;
      if (!left) tog.parentNode.removeChild(tog);
      else tog.textContent = tog.textContent.replace(/\d+/, left);
    }
  }

  /* Fast path: the page already says which colours are on sale */
  function splitEarly() {
    var list = window.TLCSaleSibs;
    if (!list || !list.length) return false;
    var box = document.querySelector('.product-form .related-swatches:not(.tlcsw--sale)');
    if (!box) return false;
    /* usually the snippet has already built the On Sale row while the page was loading:
       just sharpen its images and recount the main row */
    var done = (box.closest('.product-form') || document).querySelector('.tlcsw--sale');
    if (done) {
      done.querySelectorAll('.related-swatch img').forEach(function (i) {
        if (!i.getAttribute('data-sharp')) { sharpen(i); i.setAttribute('data-sharp', '1'); }
      });
      tidyMain(box);
      return true;
    }
    var sale = [].slice.call(box.querySelectorAll('.related-swatch')).filter(function (a) {
      return list.indexOf(handleOf(a.getAttribute('href'))) > -1;
    });
    if (sale.length) moveToSaleRow(box, sale);
    return true;
  }

  /* Fallback: look the colours up (only used where the page has no sale data) */
  function isSale(p) {
    if (!p) return false;
    var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
    if (tags.indexOf('finalsale') > -1) return true;
    return (p.variants || []).some(function (v) { return v.compare_at_price && v.compare_at_price > v.price; });
  }
  function splitByLookup(box) {
    if (window.TLCSaleSibs) return;
    var form = box.closest('.product-form') || document;
    if (form.querySelector('.tlcsw--sale')) return;
    var sw = [].slice.call(box.querySelectorAll('.related-swatch'));
    if (sw.length < 2) return;
    var handles = sw.map(function (s) {
      return s.classList.contains('tlcsw-current') ? handleOf(location.pathname) : handleOf(s.getAttribute('href'));
    });
    Promise.all(handles.map(function (h) {
      if (!h) return null;
      return fetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      var sale = sw.filter(function (s, i) { return isSale(ps[i]); });
      if (sale.length && sale.length < sw.length) moveToSaleRow(box, sale);
    });
  }

  function init(box) {
    if (box.getAttribute('data-tlcsw')) return;
    var sw = box.querySelectorAll('.related-swatch');
    if (!sw.length) return;
    box.setAttribute('data-tlcsw', '1');
    box.classList.add('tlcsw');

    /* Label: Colour  Drift Tide */
    var row = box.closest('.input-row') || box.parentElement;
    var lab = row.querySelector(':scope > .label');
    var name = colourName();
    if (lab && !lab.classList.contains('tlcsw-lab')) {
      lab.classList.add('tlcsw-lab');
      lab.innerHTML = '<span class="tlcsw-lab__k">Colour</span>' + (name ? '<span class="tlcsw-lab__v"></span>' : '');
      if (name) lab.querySelector('.tlcsw-lab__v').textContent = name;
    }

    sw.forEach(function (s) { var i = s.querySelector('img'); if (i && !i.getAttribute('data-sharp')) sharpen(i); });

    /* The colour she's on goes first (unless it sits in the On Sale row) */
    var active = box.querySelector('.related-swatch--active');
    var form = box.closest('.product-form') || document;
    var activeInSale = !!form.querySelector('.tlcsw--sale .related-swatch--active');
    if (!active && !activeInSale) {
      var og = document.querySelector('meta[property="og:image"]');
      var img = og && og.getAttribute('content');
      if (img) {
        active = document.createElement('span');
        active.className = 'related-swatch related-swatch--active tlcsw-current';
        active.setAttribute('aria-current', 'true');
        active.innerHTML = '<img alt="" loading="lazy">';
        var im = active.querySelector('img');
        var clean = img.replace(/^http:/, 'https:').replace(/^\/\//, 'https://');
        var v = (clean.match(/[?&]v=(\d+)/) || [])[1];
        im.src = clean.split('?')[0] + (v ? '?v=' + v + '&' : '?') + 'width=160';
        sharpen(im);
        im.alt = name || '';
        box.insertBefore(active, box.firstChild);
      }
    } else if (active) {
      active.classList.remove('tlc-swatch-hidden');
      if (box.firstElementChild !== active) box.insertBefore(active, box.firstChild);
    }

    tidyMain(box);
    splitByLookup(box);
  }

  function run() {
    splitEarly();
    fixSticky();
    moveWishlist();
    moveInstore();
    document.querySelectorAll('.product-form .related-swatches').forEach(init);
  }
  /* Wishlist: a small heart next to the product name (like Glassons) instead of the
     full width button under Add to cart. The Wishlist King app adds its button to the
     page after it loads, so we watch for it and move the app's own button into the title
     row (it keeps working and remembers what is saved). Main product page only. */
  function moveWishlist() {
    document.querySelectorAll('[id*="__main"] .product-form').forEach(function (f) {
      var w = f.querySelector('.buy-buttons-row wishlist-button-product');
      var t = f.querySelector('.title-row');
      if (!w || !t || t.querySelector('wishlist-button-product')) return;
      w.classList.add('tlc-wl');
      w.removeAttribute('full-width');
      w.removeAttribute('show-text');
      t.appendChild(w);
    });
  }

  function watchWishlist() {
    moveWishlist();
    if (!window.MutationObserver || !document.body) return;
    var queued = false;
    var mo = new MutationObserver(function () {
      if (queued) return; queued = true;
      requestAnimationFrame(function () { queued = false; moveWishlist(); });
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); moveWishlist(); }, 20000);
  }

  /* Check In-Store Availability (Multi-Location Stock Info app): straight under the
     Add to cart / Select your size button, styled as a plum outline button (CSS). */
  function moveInstore() {
    document.querySelectorAll('[id*="__main"] .product-form').forEach(function (f) {
      var app = f.querySelector('.shopify-block[id*="multi_location_stock_info"]');
      var bb = f.querySelector('buy-buttons');
      if (!app || !bb) return;
      var wrap = app.parentElement === f ? app : app.parentElement;
      if (wrap.classList.contains('tlc-instore') || wrap.parentElement !== f) return;
      wrap.classList.add('tlc-instore');
      bb.insertAdjacentElement('afterend', wrap);
    });
  }

  /* Sticky add to cart bar: the theme's script expects a "variant name" line in the bar
     that isn't in our markup, so it stopped part way and the bar kept the size the page
     opened on. Give it a hidden line to write to, keep the bar's size in step with the
     page, and check it again right before the bar adds to cart. */
  function mainId() {
    var i = document.querySelector('[id*="__main"] buy-buttons form [name="id"]');
    return i && i.value;
  }
  function fixSticky() {
    document.querySelectorAll('sticky-atc').forEach(function (s) {
      if (!s.variantTitle) {
        var c = document.createElement('div');
        c.className = 'sticky-atc__details__variant tlc-sticky-variant';
        c.hidden = true; c.style.display = 'none';
        var t = document.createElement('span');
        c.appendChild(t);
        (s.querySelector('.sticky-atc__details') || s).appendChild(c);
        s.variantContainer = c; s.variantTitle = t;
      }
      var si = s.querySelector('form [name="id"]'), m = mainId();
      if (si && m && si.value !== m) si.value = m;
    });
  }
  document.addEventListener('submit', function (e) {
    var s = e.target && e.target.closest && e.target.closest('sticky-atc');
    if (!s) return;
    var si = e.target.querySelector('[name="id"]'), m = mainId();
    if (si && m) si.value = m;
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('[id*="__main"] variant-picker, [id*="__main"] .option-selector')) setTimeout(fixSticky, 0);
  });

  function early() { splitEarly(); moveInstore(); watchWishlist(); fixSticky(); }
  /* On Sale row, in-store button and wishlist heart as soon as the page is read */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', early); else early();
  /* The existing swatch script sets up "+ N more colours" on load, then again 600ms later */
  window.addEventListener('load', function () { setTimeout(run, 700); });
  if (document.readyState === 'complete') setTimeout(run, 700);
})();
